/* ================================================================
   MEGA MENU — Dawn Theme  |  assets/mega-menu.js
   <script src="{{ 'mega-menu.js' | asset_url }}" defer></script>
================================================================ */
(function () {
  'use strict';

  var openPanel  = null;
  var openTrigger = null;
  var overlay    = null;

  document.addEventListener('DOMContentLoaded', function () {

    /* ── Create overlay ── */
    overlay = document.createElement('div');
    overlay.className = 'mega-menu-overlay';
    overlay.setAttribute('aria-hidden', 'true');
    document.body.appendChild(overlay);

    /* ── Wire trigger buttons ── */
    document.querySelectorAll('.mega-menu-trigger').forEach(function (trigger) {
      var btn = trigger.querySelector('button, a');
      if (!btn) return;

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var panelId = trigger.getAttribute('data-mega-panel');
        var panel   = panelId ? document.getElementById(panelId) : null;
        if (!panel) return;

        if (panel.classList.contains('is-open')) {
          closeAll();
        } else {
          closeAll();
          openPanel   = panel;
          openTrigger = trigger;
          panel.classList.add('is-open');
          panel.setAttribute('aria-hidden', 'false');
          trigger.setAttribute('aria-expanded', 'true');
          overlay.classList.add('is-active');
        }
      });
    });

    /* ── Click anywhere outside closes the menu ── */
    document.addEventListener('click', function (e) {
      if (!openPanel) return;

      /* If click is inside the open panel or its trigger, do nothing */
      var insidePanel   = openPanel.contains(e.target);
      var insideTrigger = openTrigger && openTrigger.contains(e.target);

      if (!insidePanel && !insideTrigger) {
        closeAll();
      }
    });

    /* ── Overlay click also closes (belt and braces) ── */
    overlay.addEventListener('click', function () {
      closeAll();
    });

    /* ── Escape key closes ── */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });

    /* ── Mobile accordion ── */
    document.querySelectorAll('.mega-menu-mobile__toggle').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group     = btn.closest('.mega-menu-mobile__group');
        var container = btn.closest('.mega-menu-mobile');
        var isOpen    = group.classList.contains('is-open');

        container.querySelectorAll('.mega-menu-mobile__group').forEach(function (g) {
          g.classList.remove('is-open');
          var t = g.querySelector('.mega-menu-mobile__toggle');
          if (t) t.setAttribute('aria-expanded', 'false');
        });

        if (!isOpen) {
          group.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });

  });

  function closeAll () {
    if (openPanel) {
      openPanel.classList.remove('is-open');
      openPanel.setAttribute('aria-hidden', 'true');
    }
    if (openTrigger) {
      openTrigger.setAttribute('aria-expanded', 'false');
    }
    if (overlay) {
      overlay.classList.remove('is-active');
    }
    openPanel   = null;
    openTrigger = null;
  }

})();